import { Snackbar, Alert } from '@mui/material'
import { useOnlineStatus } from '../hooks/useOnlineStatus'

export default function OfflineBanner() {
  const isOnline = useOnlineStatus()

  return (
    <Snackbar open={!isOnline} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert severity="warning" variant="filled" sx={{ width: '100%' }}>
        Sin conexión a internet. Algunas funciones no están disponibles.
      </Alert>
    </Snackbar>
  )
}
